var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hero--small"},[_c('div',{staticClass:"container--basic"},[_c('i',{class:_vm.icon}),_vm._v(" "),_c('h1',[_vm._v(_vm._s(_vm.text))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }